import * as React from 'react';
export function assignRef(ref, value) {
    if (ref === null)
        return;
    if (typeof ref === 'function') {
        ref(value);
    }
    else {
        try {
            if (!ref)
                return;
            ref.current = value;
        }
        catch (error) {
            throw new Error(`Cannot assign value "${value}" to ref "${ref}"`);
        }
    }
}
export function useMergedRefs(...refs) {
    return React.useCallback((node) => {
        for (const ref of refs) {
            assignRef(ref, node);
        }
    }, refs);
}
//# sourceMappingURL=useMergedRefs.js.map